import { loadState } from './localStorage';
import { config } from '../config/config';

import { showLoading, hideLoading } from '../actions/loading';
import { userLogout } from '../actions/auth';
import { store } from '../App';
class Api {
  static headers() {
    let currentState = loadState();
    console.log(currentState);
    if (currentState.loggedinUser && currentState.loggedinUser.auth)
      return {
        'Authorization': "Bearer " + currentState.loggedinUser.auth.accessToken
      }
    else
      return {}
  }

  static get(route, isMultipart = false) {
    return this.xhr(route, null, 'GET', isMultipart);
  }

  static put(route, params, isMultipart = false) {
    return this.xhr(route, params, 'PUT', isMultipart);
  }

  static post(route, params, isMultipart = false) {
    return this.xhr(route, params, 'POST', isMultipart);
  }

  static delete(route, params, isMultipart = false) {
    return this.xhr(route, params, 'DELETE', isMultipart);
  }

  static xhr(route, params, verb, isMultipart = false) {
    store.dispatch(showLoading());
    const host = config.apihost;
    const url = `${host}${route}`;

    let headers = Api.headers();
        headers['Accept'] =  'application/json';
        headers['dataType']= 'json';
    let options = Object.assign({ method: verb }, params ? { body: ( isMultipart ? params : JSON.stringify(params) ) } : null);

    if(isMultipart)  {
        options.mode = "cors";
    }
    else{
        headers['Content-Type'] = "application/json";
    }
        options.headers = headers;

    return new Promise((resolve, reject) => {
      fetch(url, options)
        .then(res => this.ErrorHandler(res))
        .then(resp => resp.json())
        .then(responseJson => {
          store.dispatch(hideLoading());
          resolve(responseJson)
        })
        .catch(err => {
          store.dispatch(hideLoading());
          if (err.message === "Unauthorized")
            store.dispatch(userLogout());
          reject(err)
        })
    });
  }

  static ErrorHandler(response) {
    if (!response.ok) {
      let responseText = "";
      if (response._bodyText) {
        let res = JSON.parse(response._bodyText);
        responseText = res.msg;
      }
      else if (response.statusText)
        responseText = response.statusText;
      else {
        responseText = "Return status code: " + response.status + " - Network Error";
      }
      throw Error(responseText);
    }
    return response;
  }
}

export default Api;


// WEBPACK FOOTER //
// ./src/lib/api.js